import { createSelector } from "reselect"
import viewTrackingSelector from './viewTrackingSelector'
import { ViewTrackingFilterAttribute } from "../../../entities/ViewTracking"

const viewTrackingFilterAttributesSelector = createSelector(
    viewTrackingSelector,
    (viewTracking): ViewTrackingFilterAttribute[] => viewTracking?.filters || [],
)

export default viewTrackingFilterAttributesSelector